import React from 'react'
import Navbar from '../componenst/Navbar'
import { useState, useEffect } from 'react';
import Compfotopemain from '../componenst/Memberkarir/Compfotopemain';
import axios from 'axios';
import Compnama from '../componenst/Memberkarir/Compnama';
import { Link } from 'react-router-dom';

export default function Topkiper() {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const [confetti, setConfetti] = useState([]);
    const [kiper, setKiper] = useState([]);

    const getdata = async () => {
        try {
            const response = await axios.get(urlapi + "Point_memberkarirtopkiper");
            setKiper(response.data);
            console.log(response.data);
        } catch (error) { }
    };

    useEffect(() => {
        getdata();
        const colors = ['#00d4ff', '#f2d74e', '#ffffff', '#ff0055'];
        const newConfetti = Array.from({ length: 60 }).map((_, i) => ({
            id: i,
            left: Math.random() * 100,
            color: colors[Math.floor(Math.random() * colors.length)],
            duration: Math.random() * 3 + 2,
            delay: Math.random() * 0.5,
            size: Math.random() * 10 + 5,
        }));

        setConfetti(newConfetti);
    }, []);
    return (
        <div style={{ minHeight: '100vh', borderRadius: '0px', }}>
            <Navbar judul='Top Kiper Rank Solo' aicon={true} />
            <div className="page-container">
                <div className="lightning-flash"></div>
                <div className="container-fluid py-2">
                    <div className='d-flex justify-content-between'>
                        <Link to="/rankingsolonew" className="btn btn-outline-secondary w-100">Klasement</Link>
                        <Link to='/topscoreranksolo' className="btn btn-outline-secondary w-100" style={{ marginLeft: '10px' }}>Top Scorers</Link>
                        <Link to='/topkiper' className="btn btn-secondary w-100" style={{ marginLeft: '10px' }}>Top Kiper</Link>
                    </div>
                    <div className='text-white my-3'><i className='fas fa-hand'></i> Top Kiper</div>
                    <div className='row g-2 justify-content-center'>
                        {kiper.map((data, index) => (
                            <div className="col-6 col-sm-6" key={data.id}>
                                <div className={index == 0 || index == 1 ? 'card-gold' : 'player-card'}>
                                    <div className="card-shine"></div>

                                    <div className="card-headersolo">
                                        <span className="rating">#{index + 1}</span>
                                        <span className="pos">RANK</span>
                                    </div>

                                    <div className="photo-container">
                                        {/* <Compprofil id_user={data.id_user} /> */}
                                        <Compfotopemain id_user={data.id_user} />
                                        {/* <img
                                                                      src={data.image}
                                                                      alt="Player"
                                                                      className="player-img-card"
                                                                  /> */}
                                    </div>

                                    <div className="card-content">
                                        <div className="name-wrapper">
                                            <span className="player-name">  <Compnama iduser={data.id_user} /></span>
                                            <span className="potm-label"> TOP KIPER</span>
                                            <div className="name-divider"></div>
                                        </div>

                                        {/* Di layar HP, stats-grid mungkin butuh penyesuaian */}
                                        <div className="stats-grid">
                                            {/* <StatItem val={data.jumlah_goal} lbl="GOAL" /> */}
                                            <StatItem val={data.play} lbl="PLY" />
                                            <StatItem val={data.win} lbl="WIN" />
                                            <StatItem val={data.lost} lbl="LST" />
                                            <StatItem val={data.point} lbl="PNT" />
                                        </div>

                                        <div className="logo-area" style={{ fontSize: '8px' }}>
                                            MEDAN MINI SOCCER
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

const StatItem = ({ val, lbl }) => (
    <div className="stat">
        <span className="val">{val}</span>
        <span className="lbl">{lbl}</span>
    </div>
);

